export default __webpack_public_path__ + "static/media/AE17.36e673b1.jpg";